var map = {
	"./buy_super_cn.png": 65846,
	"./buy_super_en.png": 67904,
	"./buy_super_id.png": 80798,
	"./buy_super_ko.png": 62887,
	"./buy_super_ph.png": 51173,
	"./buy_super_th.png": 37713,
	"./buy_super_zh.png": 42307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48032;